import { ProjectDataType, ShipDataType, StudyDataType } from "@/types/apiTypes";

export const shipIsInProject = (
  ship: ShipDataType,
  selectedProject: ProjectDataType,
) => {
  return ship.projects?.some((project) => project.id === selectedProject?.id);
};

export const studyIsInProject = (
  study: StudyDataType,
  selectedProject: ProjectDataType,
) => {
  return study.projects?.some((project) => project.id === selectedProject?.id);
};
